export const LOAD_CLUBS = "LOAD_CLUBS";
export const LOAD_CLUBS_SUCCESS = "LOAD_CLUBS_SUCCESS";
export const LOAD_CLUBS_FAILED = "LOAD_CLUBS_FAILED";